var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinrect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.84256 0.0100098C3.53388 0.0100098 0.00747681 3.53633 0.00747681 7.84509V32.1587C0.00747681 36.4674 3.5338 39.9925 7.84256 39.9925H32.1562C36.4649 39.9925 39.99 36.4674 39.99 32.1587V7.84509C39.99 3.53641 36.4649 0.0100098 32.1562 0.0100098H7.84256ZM9.8132 6.60793C11.8791 6.60793 13.1516 7.96417 13.1909 9.74693C13.1909 11.4903 11.879 12.8847 9.77324 12.8847H9.73448C7.70788 12.8847 6.398 11.4904 6.398 9.74693C6.398 7.96421 7.74752 6.60793 9.81316 6.60793H9.8132ZM27.6164 14.9403C31.5896 14.9403 34.568 17.5372 34.568 23.1178V33.5357H28.5299V23.8162C28.5299 21.3738 27.656 19.7075 25.4708 19.7075C23.8027 19.7075 22.8084 20.8306 22.3718 21.9156C22.2123 22.3038 22.1731 22.8459 22.1731 23.3889V33.5357H16.135C16.135 33.5357 16.2142 17.0712 16.135 15.3664H22.1744V17.9394C22.9768 16.7014 24.412 14.9403 27.6164 14.9403V14.9403ZM6.75416 15.3677H12.7923V33.5358H6.75416V15.3677Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinrect);
export default __webpack_public_path__ + "static/media/linkedinrect.0b6e4cee0a8f810d1ce1abab6acb5edf.svg";
export { ForwardRef as ReactComponent };